<template>
    <div class="user">
        <Modal
            v-model="showDelModal"
            :title="$t('confirm')+$t('lock')"
            @on-ok="showDelModal=false;lockUser(userIdToDel);"
            @on-cancel="showDelModal=false"
        >
            <p>{{$t('confirmDel')}}</p>
        </Modal>

        <div class="search">
            <Input v-model="search" :placeholder="$t('searchTips')+'...'" style="width:200px;"></Input>
            <Button type="primary" @click="loadData(currentPage)">{{$t('searchText')}}</Button>
            <Button type="primary" class="add_user" icon="md-add" @click="show_add_user = true">{{$t('add')}}{{$t('user')}}</Button>
        </div>
        <Table border :columns="columns12" :data="data6" style="width: 100%; min-height: 500px;">
        </Table>
        <div class="page">
            <Page
                :total="totalItems"
                :page-size="itemsPerPage"
                show-elevator
                :current="currentPage"
                @on-change="loadData"
            />
        </div>
        <Modal v-model="showDelModal" :title="$t('del')" @on-ok="delRow">
            <p>{{$t('confirmDel')}}</p>
        </Modal>
        <Modal v-model="showCertificateModal" :title="$t('certificate')">
            <img :src="certificateUrl" alt="" style="max-width: 500px; max-height: 900px;object-fit: cover;">
        </Modal>
    </div>
</template>


<script>
import { formatUTCTime as formatUTC } from '../../common/common.js';

export default {
    data() {
        return {
            showDelModal: false,
            userIdToDel: 0,
            currentPage: 1,
            totalItems: 0,
            totalPages: 1,
            totalItems: 1,
            itemsPerPage: 10,
            search: "",
            showCertificateModal: false,
            certificateUrl: '',
            columns12: [
                {
                    title: "ID",
                    key: "user_id"
                },
                {
                    title: this.$i18n.t('username'),
                    key: "member_username"
                },
                {
                    title: this.$i18n.t('mobile'),
                    width: 120,
                    key: "member_mobile"
                },
                {
                    title: 'Email',
                    width: 150,
                    key: "member_email",
                },
                
                {
                    title: this.$i18n.t('amount'),
                    key: "amount",
                },
                {
                    title:this.$i18n.t('network'),
                    key: "network",
                },
                {
                    title:this.$i18n.t('address'),
                    key: "address",
                },
                {
                    title:this.$i18n.t('certificate'),
                    key: "certificate",
                    render: (h, params) => {
                        return h('img', {
                            attrs: {
                                src: this.$ht_ip + params.row.certificate,
                            },
                            style: {
                                width: '100px',
                                height: '100px',
                                cursor: 'pointer'
                            },
                            on: {
                                click: () => {
                                    this.showCertificate(params.row.certificate)
                                }
                            }
                        })
                    }
                },
                {
                    title: this.$i18n.t('status'),
                    width: 100,
                    align: "center",
                    render: (h, params) => {
                        if (params.row.status == 0) {
                            return h("div", [
                                h("Select", {
                                    props: {
                                        value: params.row.status,
                                        style: {width: '100%'}
                                    },
                                    on: {
                                        'on-change': (value) => {
                                            this.edit_status(params.row, value)
                                        }
                                    }
                                }, [
                                    h("Option", {
                                        props: {
                                            value: 1
                                        }
                                    }, this.$i18n.t('pass')),
                                    h("Option", {
                                        props: {
                                            value: 2
                                        }
                                    }, this.$i18n.t('reject'))
                                ])
                            ])
                        } else {
                            return h("span", {
                                style: {
                                    color: params.row.status == 1 ? 'green' : 'red'
                                }
                            }, params.row.status == 1 ? this.$i18n.t('pass') : this.$i18n.t('reject'))
                        }
                    }
                },
                {
                    title:this.$i18n.t('note'),
                    width: 150,
                    key: "remark",
                    render: (h, params) => {
                        if (params.row.status == 2) {
                            return h("div", [
                                h("Input", {
                                    props: {
                                        value: params.row.remark || '',
                                        style: {width: '100%'}
                                    },
                                    on: {
                                        'on-blur': (event) => {
                                            this.edit_remark(params.row.id, event.target.value)
                                        }
                                    }
                                })
                            ])
                        } else {
                            return h("span", params.row.remark || '-')
                        }
                    }
                },
                {
                    title:this.$i18n.t('action'),
                    width: 110,
                    key: "action",
                    render: (h, params) => {
                        return h("div",{style:{display: 'flex', flexDirection: 'row', justifyContent: 'space-between',gap: '5px'}}, [
                            h("Icon", {
                                props: {
                                    type: 'md-trash',
                                    size: 24,
                                    color: 'white'
                                },
                                style: {
                                   backgroundColor: 'red',
                                   border: 'none',
                                   },
                                on: {
                                    click: () => {
                                        this.delModal(params.row.id)
                                    }
                                }
                            },)
                        ]);
                    }
                }
            ],
            data6: [],
        };
    },
    mounted() {
        this.loadData(1);
    },
    methods: {
        loadData(page) {
            this.currentPage = page;
            
            this.$get(this.$path.wallet_list, {
                search: this.search,
                page: this.currentPage,
                type: "charge"
            }).then(res => {
                if (res.data) {
                    this.data6 = res.data.list;
                    this.totalItems = res.data.pageObj.totalSize;
                    this.itemsPerPage = res.data.pageObj.pageSize;
                } else {
                    this.$Message.error(this.$i18n.t('dataFailed'));
                }
            });
        },
        showUserDetail(user_id) {
            this.$router.push({
                name: "user_detail",
                query: {
                    user_id: user_id
                }
            });
        },
         edit_status(row, status) {
            this.$post(this.$path.wallet_edit, {
                id: row.id,
                user_id: row.user_id,
                type: "charge",
                status: status,
                amount: Number(row.amount),
            }).then(res => {
                if (res.success) {
                    this.$Message.success(this.$i18n.t('operateSuccess'));
                    this.loadData(this.currentPage);
                }
            });
        },
        edit_remark(id, remark) {
            this.$post(this.$path.wallet_edit, {
                id: id,
                remark: remark
            }).then(res => {
                if (res.success) {
                    this.$Message.success(this.$i18n.t('operateSuccess'));
                    this.loadData(this.currentPage);
                }
            });
        },
        delModal(id) {
            this.userIdToDel = id;
            this.showDelModal = true;
        },
       
        delRow() {
            this.$post(this.$path.wallet_del, {
                id: this.userIdToDel
            }).then(res => {
                if (res.success) {
                    this.$Message.success(this.$i18n.t('operateSuccess'));
                    this.loadData(this.currentPage);
                }
            });
        },
        showCertificate(certificate) {
            this.certificateUrl = this.$ht_ip + certificate;
            this.showCertificateModal = true;
        },
        closeCertificateModal() {
            this.showCertificateModal = false;
            this.certificateUrl = '';
        },
        formatUTCTime(utcTimeString) {
            return formatUTC(utcTimeString, 8); // 使用东八区
        }
    }
};
</script>


<style lang="scss" scoped>
.search {
    margin-bottom: 20px;
    .add_user {
        float: right;
    }
}
.page {
    margin-top: 20px;
    display: flex;
    justify-content: center;
}
</style>



// WEBPACK FOOTER //
// src/components/crypto/recharge.vue